import React from 'react';
import { hot } from 'react-hot-loader';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { BreadCrumbs } from './common';
import InfoTooltip from './eReceipts/InfoTooltip';
import LeftNavigation from './LeftNavigation/LeftNavigation';
import {
  ReturnsMobileLinks,
  OrderDetailsLink,
  OrderTrackingLink,
  MyAccountLink,
  InStoreSummaryLink,
} from './common/MobileHeaderLinks';
import SiteSwitch from '../routes/SiteSwitch';
import { getDevice } from '../reducers';

import { ROUTES } from '../constants';
import { getIsUserLoggedIn } from '../utils/cookie';
import { redirectToPath, getCmMmcQueryString } from '../utils/window';

type Props = {
  history: Object,
  isMobile: boolean,
};

const isAuth = getIsUserLoggedIn();

const mobileLinks = {
  'Online Orders': isAuth ? <MyAccountLink /> : <OrderTrackingLink />,
  'Cancel Items': <OrderDetailsLink />,
  'Start a Return': <ReturnsMobileLinks isAuth={isAuth} />,
  'Cancel Appliance': <OrderDetailsLink />,
  'In-Store Orders': isAuth ? <MyAccountLink /> : <OrderTrackingLink />,
  'Order Details': <InStoreSummaryLink />,
  'In-Store e-Receipts': <MyAccountLink />,
};

function App(props: Props) {
  const { history, isMobile } = props;
  const { pathname } = history.location;
  const pageHeader = ROUTES.BREADCRUMB[pathname];
  const requireHfapp = !(
    pathname === ROUTES.PATH.ONLINE_RECEIPTS ||
    pathname === ROUTES.PATH.ONLINE_AUTH_RECEIPTS ||
    pathname === ROUTES.PATH.CUST_SERV_AGREEMENT
  );

  // redirect authenticated users;
  if (pathname === ROUTES.PATH.ORDER_TRACKING && isAuth) {
    const queryString = getCmMmcQueryString();
    if (queryString) {
      redirectToPath(`${ROUTES.URL.ORDER_HISTORY}?${queryString}`);
      return null;
    }
    redirectToPath(ROUTES.URL.ORDER_HISTORY);
    return null;
  }
  return (
    <div className="col__12-12">
      {/* Breadcrumb Links */}
      {/* Show only for desktop view and not receipt page */}
      {!isMobile && requireHfapp && <BreadCrumbs />}
      {isMobile &&
        [
          'Online Orders',
          'Cancel Items',
          'Start a Return',
          'In-Store Orders',
          'Cancel Appliance',
          'Order Details',
          'In-Store e-Receipts',
        ].indexOf(pageHeader) !== -1 &&
        mobileLinks[pageHeader]}
      {/* Page Header */}
      {pageHeader && (
        <h3
          className="grid flush u--margin-top"
          data-automation-id="orderPageHeader"
        >
          {pageHeader}
          {pageHeader === 'In-Store e-Receipts' && <InfoTooltip />}
        </h3>
      )}
      {/* Site Switch: all site components will be rendered through this component */}
      {getIsUserLoggedIn() && requireHfapp ? (
        <div className="grid u--marginLarge-top">
          <div className="u--hide show--xs col__3-12--xs">
            <LeftNavigation />
          </div>
          <div className="col__12-12 col__9-12--xs">
            <SiteSwitch />
          </div>
        </div>
      ) : (
        <div className="grid u--marginLarge-top">
          <SiteSwitch />
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state: Object) => ({
  isMobile: getDevice(state, 'mobile'),
});

export default hot(module)(withRouter(connect(mapStateToProps)(App)));
